import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { goToTop } from '../Components/goToTop';
import { Ripple } from 'primereact/ripple';
import { useSelector } from 'react-redux';
import { hasPermission } from '../Controllers/Selectors/permissionsSelector';
import { RootState } from '../Controllers/Store';
import SideBarLoading from './SideBarLoading';
import { useAppDispatch, useAppSelector } from '../Controllers/hooks';
import InfoModal from '../Components/InfoModal';
import { MenuBarPermission } from '../Controllers/Types/NewPermission/MenuBarPermission';
import { getAllNewPermissionsThunk } from '../Controllers/Thunks/NewPermissionThunks';
import { OverlayPanel } from 'primereact/overlaypanel';
import { checkIsBuildingInspector, getLoginUserRoleName, UserRoleName } from '../Utils/LoginUserRoleName';
import { getSideMenuOptionService } from '../Api/HeyTraderService/SideMenuControlService';
import { mapSiteMenuOptions, SiteMenuOption } from '../Controllers/Types/SideMenuBar/SiteMenuOption';
import { DefaultPackage } from '../Controllers/Types/Project/DefaultPackageInterface';
import { fetchAllDefaultPackages } from '../Controllers/Slices/projectDetailsSlice';
import { Service } from '../Controllers/Types/Project/Service/ServiceInterface';
import { ShareContact } from '../Controllers/Types/Project/ShareContactInterface';
// import { getAllSpendingProjectList } from '../Controllers/Thunks/HeyTraderThunks';

interface SidebarProps {
    isOpen: boolean;
    toggleSidebar: () => void;
    sideBar?: React.RefObject<HTMLDivElement>;
}

interface DisabledNavItemProps {
    label: string;
    icon: string;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, toggleSidebar, sideBar }) => {
    const path: string = window.location.pathname;
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(true);
    const dispatch = useAppDispatch();
    const blockedFeatureInfoPanel = useRef<OverlayPanel>(null);
    const viewOnlyFeatureInfoPanel = useRef<OverlayPanel>(null);

    // CHANGE 1
    const [loginUserRoleName, setLoginUserRoleName] = useState<UserRoleName | ''>('');

    // menubar with permission
    const [menubarItems, setMenubarItems] = useState<MenuBarPermission[]>([]);
    const [menuOptions, setSiteMenuOptions] = useState<SiteMenuOption[]>([]);

    useEffect(() => {
        dispatch(getAllNewPermissionsThunk());
        // new chnages contribute from dinesh
        // dispatch(getAllSpendingProjectList());

    }, [dispatch]);

    // new chnages contribute from dinesh
    useEffect(() => {
        const getOptionMenuData = async () => {
            const res = await getSideMenuOptionService();
            const options = mapSiteMenuOptions(res.body);
            setSiteMenuOptions(options);
        };
        getOptionMenuData();
    }, []);


    useEffect(() => {
        dispatch(fetchAllDefaultPackages());
    }, [dispatch]);

    const {
        loadingDefaultPackage,
        allDefaultPackages,
    } = useAppSelector((state) => state.projectDetails);

    // check is lock
    const checkHaveProject = (keyname: string): boolean => {
        if (loginUserRoleName === "commercial client" || loginUserRoleName === "domestic client") {
            const filterdata = menuOptions.filter((e) => e.menu_key_name === keyname);
            if (filterdata && filterdata?.length > 0) {
                const x = filterdata[0];
                return (x.shared_project_count > 0);
            } else {
                return false;
            }
        } else {
            return true;
        }
    }

    // this is get data from state list and set projectlist
    const loadingPermission = useAppSelector((state) => state.newPermission.loadingPermission);
    const menus = useAppSelector((state) => state.newPermission.permissions);

    useEffect(() => {
        if (menus && menus?.length > 0) {
            setMenubarItems(menus);
        }
    }, [menus])

    const returnPermissionModel = (menuName: string): MenuBarPermission | null => {
        const val = menubarItems.find((e) => e.menu_key_name === menuName);
        if (val && val !== null) {
            return val;
        } else {
            return null;
        }
    }

    // CHANGE 2
    useEffect(() => {
        const fetchUserRole = async () => {
            const roleName = await getLoginUserRoleName();
            setLoginUserRoleName(roleName);
        };

        fetchUserRole();
    }, []);


    // check is lock
    const checkMenuLock = (menu: MenuBarPermission | null): boolean => {
        if (menu && menu !== null) {
            // is_loc=>true ->show log or unlock
            // view=> share or orginal permission with out button disable
            // have feature => permission grand
            if (menu.have_feature) {
                return menu.have_feature;
            } else {
                return menu.view;
            }
        } else {
            return false;
        }
    }

    // Show lock symbol
    const showLockSymbol = (menu: MenuBarPermission | null): boolean => {
        if (menu && menu !== null) {
            return (menu.is_log && !menu.view);
        } else {
            return false;
        }
    }

    // Show view only symbol
    const showViewOnlySymbol = (menu: MenuBarPermission | null): boolean => {
        if (menu && menu !== null) {
            return (menu.is_log && menu.view);
        } else {
            return false;
        }
    }

    const notMenuNeed = (menu: MenuBarPermission | null): boolean => {
        if (menu && menu != null) {
            if (menu.have_feature === false) {
                return false;
            }
            else if (menu?.have_feature === true) {
                return true;
            } else if (menu?.view === true) {
                return true;
            } else if (menu?.is_log === false && menu.have_feature === false) {
                return false
            } else {
                return true
            }
        }
        else {
            return false;
        }

    }

    const loadingSidebar = useAppSelector((state) => state.permission.loadingPermission);

    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) => hasPermission(state, screen, permission));
    };

    const isContactActive = location.pathname.startsWith('/contact');
    const isProjectActive = location.pathname.startsWith('/project') && !location.pathname.startsWith('/project-spending');
    const isTaskActive = location.pathname.startsWith('/task');
    const isToDoActive = location.pathname.startsWith('/to-do');
    const isInvoiceActive = location.pathname.startsWith('/invoice');
    const isFaqActive = location.pathname.startsWith('/app-faq');
    const isMySubscriptionActive = location.pathname.startsWith('/my-subscription');
    const isContactUsActive = location.pathname.startsWith('/app-contact-us');
    const isToolsActive = location.pathname.startsWith('/tools');
    const isAttendanceActive = location.pathname.startsWith('/attendance');
    const isMaterialsActive = location.pathname.startsWith('/materials');
    const isProjectSpendingActive = location.pathname.startsWith('/project-spending');
    const isShoppingListActive = location.pathname.startsWith('/shopping-list');
    const isClientAccountActive = location.pathname.startsWith('/client-account');
    const isQuotationActive = location.pathname.startsWith('/quotation');
    const isBuildingControlActive = location.pathname.startsWith('/building-control');
    const isFinishingSheduleActive = location.pathname.startsWith('/finishing-shedule');

    const canEditHome = useCanEdit('Bottom Navigation Options', 'Home');
    const canEditContact = useCanEdit('Bottom Navigation Options', 'Contact');
    const canEditProject = useCanEdit('Bottom Navigation Options', 'Project');
    const canEditTask = useCanEdit('Bottom Navigation Options', 'Task');
    const canEditTodoList = useCanEdit('Bottom Navigation Options', 'Todo List');
    const canEditPayment = useCanEdit('Bottom Navigation Options', 'Payment');
    const canEditTools = useCanEdit('Bottom Navigation Options', 'tools');
    const canEditShoppingList = useCanEdit('Bottom Navigation Options', 'shopping-list');
    const canEditAttendance = useCanEdit('Bottom Navigation Options', 'attendance');
    const canEditMaterials = useCanEdit('Bottom Navigation Options', 'materials');
    const canEditProjectSpending = useCanEdit('Bottom Navigation Options', 'project-spending');
    const canEditClientAccount = useCanEdit('Bottom Navigation Options', 'client-account');
    const canEditQuotation = useCanEdit('Bottom Navigation Options', 'quotation');
    const canEditBuildingControl = useCanEdit('Bottom Navigation Options', 'Building Control');

    const [showInfoModal, setShowInfoModal] = useState<boolean>(false);

    const [shortCutServices, setShortCutServices] = useState<DefaultPackage[]>([]);

    // CHANGE 2
    useEffect(() => {
        const fetchUserRole = async () => {
            const roleName = await getLoginUserRoleName();
            setLoginUserRoleName(roleName);
        };

        fetchUserRole();
    }, []);


    /* Check role */
    const [isInspector, setIsInspector] = useState<boolean>(false);

    useEffect(() => {
        const checkRole = async () => {
            const [inspectorResult] = await Promise.all([
                checkIsBuildingInspector(),
            ]);

            setIsInspector(inspectorResult);
        };

        checkRole();
    }, []);
    /*  */

    useEffect(() => {
        if (!allDefaultPackages || allDefaultPackages?.length === 0) {
            setShortCutServices([]);
            return;
        }

        const activeServices = allDefaultPackages?.filter((service) => service?.show_shortcut === 1);

        setShortCutServices(activeServices);
    }, [allDefaultPackages]);


    const handleShowInfoModal = () => {
        setShowInfoModal(true);
    }

    const handleCloseInfoModal = () => {
        setShowInfoModal(false);
    }

    useEffect(() => {
        if (loadingSidebar === false) {
            setLoading(false);
        }
    }, [loadingSidebar]);

    const handleShowBlockedFeatureInfo = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();

        // setShowInfoModal(true);

        if (blockedFeatureInfoPanel.current) {
            blockedFeatureInfoPanel.current.hide();
            setTimeout(() => blockedFeatureInfoPanel.current?.show(e, e.currentTarget), 50);
        }
    }

    const handleCloseBlockedFeatureInfoPanel = (e: React.MouseEvent<HTMLElement>) => {
        if (blockedFeatureInfoPanel.current) {
            blockedFeatureInfoPanel.current.hide();
        }
    }

    const renderLockIcon = () => {
        return (
            <i className='ri ri-lock-fill lock_icon'
                onMouseOver={(e) => handleShowBlockedFeatureInfo(e)}
                onMouseLeave={(e) => handleCloseBlockedFeatureInfoPanel(e)}
            ></i>
        )
    }

    const handleShowViewOnlyFeatureInfo = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();

        if (viewOnlyFeatureInfoPanel.current) {
            viewOnlyFeatureInfoPanel.current.hide();
            setTimeout(() => viewOnlyFeatureInfoPanel.current?.show(e, e.currentTarget), 50);
        }
    }

    const handleCloseViewOnlyFeatureInfoPanel = (e: React.MouseEvent<HTMLElement>) => {
        if (viewOnlyFeatureInfoPanel.current) {
            viewOnlyFeatureInfoPanel.current.hide();
        }
    }

    const renderViewOnlyIcon = () => {
        return (
            <i className='ri-error-warning-fill lock_icon'
                onMouseOver={(e) => handleShowViewOnlyFeatureInfo(e)}
                onMouseLeave={(e) => handleCloseViewOnlyFeatureInfoPanel(e)}
            ></i>
        )
    }

    const DisabledNavItem: React.FC<DisabledNavItemProps> = ({ label, icon }) => {
        return (
            <span className="side_nav_link disabled">
                <i className={icon}></i>
                <span className="side_bar_label">{label}</span>
            </span>
        );
    };

    const clearShortCutLink = () => {
        localStorage.removeItem('activeServiceShortCutId');
    }

    const navLinkClick = () => {
        clearShortCutLink();
        goToTop();
        toggleSidebar();
    }



    // new logic
    
      //goToService
     


    return (
        <React.Fragment>
            <OverlayPanel ref={blockedFeatureInfoPanel} className="project_info_panel" dismissable>
                <p className='mb-0'>
                    <i className='bi bi-info-circle me-1'></i>
                    You do not have permission to access this feature.
                </p>
            </OverlayPanel>

            <OverlayPanel ref={viewOnlyFeatureInfoPanel} className="project_info_panel" dismissable>
                <p className='mb-0'>
                    <i className='bi bi-info-circle me-1'></i>
                    You only have permission to view this.
                </p>
            </OverlayPanel>

            <div className={`menu_backdrop ${isOpen ? 'show' : ''}`} onClick={toggleSidebar}></div>

            <aside className={`side_bar ${isOpen ? 'show' : ''}`} ref={sideBar}>
                <div className="side_bar_content_area">
                    {loading || loadingPermission || loadingDefaultPackage ? (
                        <SideBarLoading />
                    ) : (
                        <ul className="side_nav_list">
                            {/* Home menu */}
                            {(returnPermissionModel('home') && notMenuNeed(returnPermissionModel('home'))) && (
                                <React.Fragment>
                                    <li className="side_nav_item">
                                        {checkMenuLock(returnPermissionModel('home')) ? (
                                            <Link
                                                to={'dash-board'}
                                                state={{ menuPermission: returnPermissionModel('home') }}
                                                onClick={navLinkClick}
                                                className={`side_nav_link p-ripple ${path === '/dash-board' ? 'active' : ''}`}>
                                                <i className="ri-home-6-line"></i>
                                                <span className='side_bar_label'>Home</span>

                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </Link>
                                        ) : (
                                            <DisabledNavItem
                                                icon='ri-home-6-line'
                                                label='Home'
                                            />
                                        )}

                                        {(showLockSymbol(returnPermissionModel('home'))) && (renderLockIcon())}
                                        {(showViewOnlySymbol(returnPermissionModel('home'))) && (renderViewOnlyIcon())}
                                    </li>
                                </React.Fragment>
                            )}

                            {/* Contact menu */}
                            {(returnPermissionModel('contact') && notMenuNeed(returnPermissionModel('contact'))) && (
                                <React.Fragment>
                                    <li className="side_nav_item">
                                        {checkMenuLock(returnPermissionModel('contact')) ? (
                                            <Link
                                                to={'contact'}
                                                state={{ menuPermission: returnPermissionModel('contact') }}
                                                onClick={() => {
                                                    navLinkClick();
                                                    localStorage.setItem('activeContactsDataViewMode', 'all');
                                                }}
                                                className={`side_nav_link p-ripple ${isContactActive ? 'active' : ''}`}>
                                                <i className="ri-user-3-line"></i>
                                                <span className='side_bar_label'>Contact</span>

                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </Link>
                                        ) : (
                                            <DisabledNavItem
                                                icon='ri-user-3-line'
                                                label='Contact'
                                            />
                                        )}

                                        {(showLockSymbol(returnPermissionModel('contact'))) && (renderLockIcon())}
                                        {(showViewOnlySymbol(returnPermissionModel('contact'))) && (renderViewOnlyIcon())}
                                    </li>
                                </React.Fragment>
                            )}

                            {/* Project menu */}
                            {(returnPermissionModel('project') && notMenuNeed(returnPermissionModel('project'))) && (
                                <React.Fragment>
                                    <li className="side_nav_item">
                                        {checkMenuLock(returnPermissionModel('project')) ? (
                                            <Link
                                                to={'project'}
                                                state={{ menuPermission: returnPermissionModel('project') }}
                                                onClick={() => {
                                                    navLinkClick();
                                                    localStorage.setItem('activeProjectTab', 'all');
                                                    localStorage.setItem("activeProjectViewType", 'My project');
                                                    localStorage.setItem("activeSharedFolderCategory", 'Others');
                                                }}
                                                className={`side_nav_link p-ripple ${isProjectActive ? 'active' : ''}`}>
                                                <i className="ri-stack-line"></i>
                                                <span className='side_bar_label'>Project</span>

                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </Link>
                                        ) : (
                                            <DisabledNavItem
                                                icon='ri-stack-line'
                                                label='Project'
                                            />
                                        )}

                                        {(showLockSymbol(returnPermissionModel('project'))) && (renderLockIcon())}
                                        {(showViewOnlySymbol(returnPermissionModel('project'))) && (renderViewOnlyIcon())}
                                    </li>

                                    {isInspector && (
                                        <React.Fragment>
                                            {shortCutServices && shortCutServices?.length > 0 && (
                                                <React.Fragment>
                                                    {shortCutServices?.map((service) => {
                                                        const storedServiceShortcutId = localStorage.getItem('activeServiceShortCutId');
                                                        const isServiceShortcutActive = location.pathname.startsWith('/service/projects') && (storedServiceShortcutId === (service.id).toString());

                                                        return (
                                                            <li key={`shortcut_${service?.id}`} className="side_nav_item">
                                                                <Link
                                                                    to={'service/projects'}
                                                                    state={{ menuPermission: returnPermissionModel('project'), service }}
                                                                    onClick={() => {
                                                                        localStorage.setItem('activeServiceShortCutId', (service?.id).toString());
                                                                        localStorage.setItem('activeServiceProjectTab', 'All');
                                                                        toggleSidebar();
                                                                        goToTop();
                                                                    }}
                                                                    className={`side_nav_link sub ${isServiceShortcutActive ? 'active' : ''} p-ripple `}>
                                                                    <i className="ri-arrow-right-s-line"></i>
                                                                    <span className='side_bar_label'>{service?.feature_name}</span>

                                                                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                                </Link>
                                                            </li>
                                                        )
                                                    })}
                                                </React.Fragment>
                                            )}
                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                            )}

                            {/* Building Control menu */}
                            {(returnPermissionModel('buildingcontrol') && notMenuNeed(returnPermissionModel('buildingcontrol'))) && (
                                <React.Fragment>
                                    <li className="side_nav_item">
                                        {checkMenuLock(returnPermissionModel('buildingcontrol')) ? (
                                            <Link
                                                to={'building-control/projects'}
                                                state={{ menuPermission: returnPermissionModel('buildingcontrol') }}
                                                onClick={() => {
                                                    navLinkClick();
                                                    localStorage.setItem('activeBuildingControlProjectTab', 'All');
                                                }}
                                                className={`side_nav_link p-ripple ${isBuildingControlActive ? 'active' : ''}`}>
                                                <i className="ri-hotel-line"></i>
                                                <span className='side_bar_label'>Building Control</span>

                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </Link>
                                        ) : (
                                            <DisabledNavItem
                                                icon='ri-hotel-line'
                                                label='Building Control'
                                            />
                                        )}

                                        {(showLockSymbol(returnPermissionModel('buildingcontrol'))) && (renderLockIcon())}
                                        {(showViewOnlySymbol(returnPermissionModel('buildingcontrol'))) && (renderViewOnlyIcon())}
                                    </li>
                                </React.Fragment>
                            )}

                            {(
                                (returnPermissionModel('home') && notMenuNeed(returnPermissionModel('home'))) ||
                                (returnPermissionModel('contact') && notMenuNeed(returnPermissionModel('contact'))) ||
                                (returnPermissionModel('project') && notMenuNeed(returnPermissionModel('project'))) ||
                                (returnPermissionModel('buildingcontrol') && notMenuNeed(returnPermissionModel('buildingcontrol')))
                            ) && (
                                    <hr className='border-secondary side_bar_divider' />
                                )}

                            {/* Task menu */}
                            {(returnPermissionModel('task') && notMenuNeed(returnPermissionModel('task'))) && (
                                <React.Fragment>
                                    <li className="side_nav_item">
                                        {checkMenuLock(returnPermissionModel('task')) ? (
                                            <Link
                                                to={'task'}
                                                state={{ menuPermission: returnPermissionModel('task') }}
                                                onClick={navLinkClick}
                                                className={`side_nav_link p-ripple ${isTaskActive ? 'active' : ''}`}>
                                                <i className="ri-survey-line"></i>
                                                <span className='side_bar_label'>Task</span>

                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </Link>
                                        ) : (
                                            <DisabledNavItem
                                                icon='ri-survey-line'
                                                label='Task'
                                            />
                                        )}

                                        {(showLockSymbol(returnPermissionModel('task'))) && (renderLockIcon())}
                                        {(showViewOnlySymbol(returnPermissionModel('task'))) && (renderViewOnlyIcon())}
                                    </li>
                                </React.Fragment>
                            )}

                            {/* To-Do list menu */}
                            {(returnPermissionModel('todolist') && notMenuNeed(returnPermissionModel('todolist'))) && (
                                <React.Fragment>
                                    <li className="side_nav_item">
                                        {checkMenuLock(returnPermissionModel('todolist')) ? (
                                            <Link
                                                to={'to-do'}
                                                state={{ menuPermission: returnPermissionModel('todolist') }}
                                                onClick={navLinkClick}
                                                className={`side_nav_link p-ripple ${isToDoActive ? 'active' : ''}`}>
                                                <i className="ri-list-check-3"></i>
                                                <span className='side_bar_label'>To do list</span>

                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </Link>
                                        ) : (
                                            <DisabledNavItem
                                                icon='ri-list-check-3'
                                                label='To do list'
                                            />
                                        )}

                                        {(showLockSymbol(returnPermissionModel('todolist'))) && (renderLockIcon())}
                                        {(showViewOnlySymbol(returnPermissionModel('todolist'))) && (renderViewOnlyIcon())}
                                    </li>
                                </React.Fragment>
                            )}

                            {/* Payment menu */}
                            {(returnPermissionModel('payment') && notMenuNeed(returnPermissionModel('payment'))) && (
                                <React.Fragment>
                                    <li className="side_nav_item">
                                        {checkMenuLock(returnPermissionModel('payment')) ? (
                                            <Link
                                                to={'invoice'}
                                                state={{ menuPermission: returnPermissionModel('payment') }}
                                                onClick={navLinkClick}
                                                className={`side_nav_link p-ripple ${isInvoiceActive ? 'active' : ''}`}>
                                                <i className="ri-bill-line"></i>
                                                <span className='side_bar_label'>Invoice</span>

                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </Link>
                                        ) : (
                                            <DisabledNavItem
                                                icon='ri-bill-line'
                                                label='Invoice'
                                            />
                                        )}

                                        {(showLockSymbol(returnPermissionModel('payment'))) && (renderLockIcon())}
                                        {(showViewOnlySymbol(returnPermissionModel('payment'))) && (renderViewOnlyIcon())}
                                    </li>
                                </React.Fragment>
                            )}

                            {/* Tools menu */}
                            {(returnPermissionModel('tools') && notMenuNeed(returnPermissionModel('tools'))) && (
                                <React.Fragment>
                                    <li className="side_nav_item">
                                        {checkMenuLock(returnPermissionModel('tools')) ? (
                                            <Link
                                                to={'tools'}
                                                state={{ menuPermission: returnPermissionModel('tools') }}
                                                onClick={navLinkClick}
                                                className={`side_nav_link p-ripple ${isToolsActive ? 'active' : ''}`}>
                                                <i className="ri-tools-fill"></i>
                                                <span className='side_bar_label'>Tools</span>

                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </Link>
                                        ) : (
                                            <DisabledNavItem
                                                icon='ri-tools-fill'
                                                label='Tools'
                                            />
                                        )}

                                        {(showLockSymbol(returnPermissionModel('tools'))) && (renderLockIcon())}
                                        {(showViewOnlySymbol(returnPermissionModel('tools'))) && (renderViewOnlyIcon())}
                                    </li>
                                </React.Fragment>
                            )}

                            {/* Attendance menu */}
                            {(returnPermissionModel('attendance') && notMenuNeed(returnPermissionModel('attendance'))) && (
                                <React.Fragment>
                                    <li className="side_nav_item">
                                        {(checkMenuLock(returnPermissionModel('attendance')) && checkHaveProject('attendance')) ? (
                                            <Link
                                                to={'attendance'}
                                                state={{ menuPermission: returnPermissionModel('attendance') }}
                                                onClick={() => {
                                                    navLinkClick();
                                                    localStorage.setItem('activeAttendanceView', 'Day');
                                                }}
                                                className={`side_nav_link p-ripple ${isAttendanceActive ? 'active' : ''}`}>
                                                <i className="ri-user-follow-line"></i>
                                                <span className='side_bar_label'>Attendance</span>

                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </Link>
                                        ) : (
                                            <DisabledNavItem
                                                icon='ri-user-follow-line'
                                                label='Attendance'
                                            />
                                        )}

                                        {(showLockSymbol(returnPermissionModel('attendance'))) && (renderLockIcon())}
                                        {(showViewOnlySymbol(returnPermissionModel('attendance'))) && (renderViewOnlyIcon())}
                                    </li>
                                </React.Fragment>
                            )}

                            {/* Material menu */}
                            {(returnPermissionModel('materials') && notMenuNeed(returnPermissionModel('materials'))) && (
                                <React.Fragment>
                                    <li className="side_nav_item">
                                        {(checkMenuLock(returnPermissionModel('materials')) && checkHaveProject('materials')) ? (
                                            <Link
                                                // to={'materials/projects'}
                                                to={(loginUserRoleName === "commercial client" || loginUserRoleName === "domestic client") ? 'materials' : 'materials/projects'}
                                                state={{ menuPermission: returnPermissionModel('materials') }}
                                                onClick={navLinkClick}
                                                className={`side_nav_link p-ripple ${(isMaterialsActive) ? 'active' : ''}`}>
                                                <i className="ri-box-1-line"></i>
                                                <span className='side_bar_label'>Materials</span>

                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </Link>
                                        ) : (
                                            <DisabledNavItem
                                                icon='ri-box-1-line'
                                                label='Materials'
                                            />
                                        )}

                                        {(showLockSymbol(returnPermissionModel('materials'))) && (renderLockIcon())}
                                        {(showViewOnlySymbol(returnPermissionModel('materials'))) && (renderViewOnlyIcon())}
                                    </li>
                                </React.Fragment>
                            )}

                            {/* Project spending menu */}
                            {(returnPermissionModel('projectspending') && notMenuNeed(returnPermissionModel('projectspending'))) && (
                                <React.Fragment>
                                    <li className="side_nav_item">
                                        {(checkMenuLock(returnPermissionModel('projectspending')) && checkHaveProject('projectspending')) ? (
                                            <Link
                                                to={(loginUserRoleName === "commercial client" || loginUserRoleName === "domestic client") ? 'project-spending' : 'project-spending/projects'}
                                                state={{ menuPermission: returnPermissionModel('projectspending') }}
                                                onClick={navLinkClick}
                                                className={`side_nav_link p-ripple ${isProjectSpendingActive ? 'active' : ''}`}>
                                                <i className="ri-file-list-3-line"></i>
                                                <span className='side_bar_label'>Project spending</span>

                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </Link>
                                        ) : (
                                            <DisabledNavItem
                                                icon='ri-file-list-3-line'
                                                label='Project spending'
                                            />
                                        )}

                                        {(showLockSymbol(returnPermissionModel('projectspending'))) && (renderLockIcon())}
                                        {(showViewOnlySymbol(returnPermissionModel('projectspending'))) && (renderViewOnlyIcon())}
                                    </li>
                                </React.Fragment>
                            )}

                            {/* Client account menu */}
                            {(returnPermissionModel('clientaccount') && notMenuNeed(returnPermissionModel('clientaccount'))) && (
                                <React.Fragment>
                                    <li className="side_nav_item">
                                        {(checkMenuLock(returnPermissionModel('clientaccount')) && checkHaveProject('clientaccount')) ? (
                                            <Link
                                                // to={'client-account/projects'}
                                                to={(loginUserRoleName === "commercial client" || loginUserRoleName === "domestic client") ? 'client-account' : 'client-account/projects'}
                                                state={{ menuPermission: returnPermissionModel('clientaccount') }}
                                                onClick={navLinkClick}
                                                className={`side_nav_link p-ripple ${isClientAccountActive ? 'active' : ''}`}>
                                                <i className="ri-bank-line"></i>
                                                <span className='side_bar_label'>Client account</span>

                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </Link>
                                        ) : (
                                            <DisabledNavItem
                                                icon='ri-bank-line'
                                                label='Client account'
                                            />
                                        )}

                                        {(showLockSymbol(returnPermissionModel('clientaccount'))) && (renderLockIcon())}
                                        {(showViewOnlySymbol(returnPermissionModel('clientaccount'))) && (renderViewOnlyIcon())}
                                    </li>
                                </React.Fragment>
                            )}

                            {/* Quotation menu */}
                            {returnPermissionModel('quotation') && (
                                <React.Fragment>
                                    <li className="side_nav_item">
                                        {checkMenuLock(returnPermissionModel('quotation')) ? (
                                            <Link
                                                to={'quotation'}
                                                state={{ menuPermission: returnPermissionModel('quotation') }}
                                                onClick={navLinkClick}
                                                className={`side_nav_link p-ripple ${isQuotationActive ? 'active' : ''}`}>
                                                <i className="ri-file-text-line"></i>
                                                <span className='side_bar_label'>Quotation</span>

                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </Link>
                                        ) : (
                                            <DisabledNavItem
                                                icon='ri-file-text-line'
                                                label='Quotation'
                                            />
                                        )}

                                        {(showLockSymbol(returnPermissionModel('quotation'))) && (renderLockIcon())}
                                        {(showViewOnlySymbol(returnPermissionModel('quotation'))) && (renderViewOnlyIcon())}
                                    </li>
                                </React.Fragment>
                            )}

                            {/* Finishing schedule menu */}
                            {(returnPermissionModel('finishingschedule') && notMenuNeed(returnPermissionModel('finishingschedule'))) && (
                                <React.Fragment>
                                    <li className="side_nav_item">
                                        {checkMenuLock(returnPermissionModel('finishingschedule')) ? (
                                            <Link
                                                to={'finishing-shedule/projects'}
                                                state={{ menuPermission: returnPermissionModel('finishingschedule') }}
                                                onClick={() => {
                                                    navLinkClick();
                                                    localStorage.setItem("activeFSFeatureId", '');
                                                    localStorage.setItem("activeBathroomLocationId", '');
                                                    localStorage.setItem("activeTileLocationId", '');
                                                    localStorage.setItem("activeLightLocationId", '');
                                                    localStorage.setItem("activeOthersLocationId", '');
                                                }}
                                                className={`side_nav_link p-ripple ${isFinishingSheduleActive ? 'active' : ''}`}>
                                                <i className="ri-calendar-check-line"></i>
                                                <span className='side_bar_label'>Finishing schedule</span>

                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </Link>
                                        ) : (
                                            <DisabledNavItem
                                                icon='ri-calendar-check-line'
                                                label='Finishing schedule'
                                            />
                                        )}

                                        {(showLockSymbol(returnPermissionModel('finishingschedule'))) && (renderLockIcon())}
                                        {(showViewOnlySymbol(returnPermissionModel('finishingschedule'))) && (renderViewOnlyIcon())}
                                    </li>
                                </React.Fragment>
                            )}

                            {(
                                (returnPermissionModel('task') && notMenuNeed(returnPermissionModel('task'))) ||
                                (returnPermissionModel('todolist') && notMenuNeed(returnPermissionModel('todolist'))) ||
                                (returnPermissionModel('payment') && notMenuNeed(returnPermissionModel('payment'))) ||
                                (returnPermissionModel('tools') && notMenuNeed(returnPermissionModel('tools'))) ||
                                (returnPermissionModel('shoppinglist') && notMenuNeed(returnPermissionModel('shoppinglist'))) ||
                                (returnPermissionModel('attendance') && notMenuNeed(returnPermissionModel('attendance'))) ||
                                (returnPermissionModel('materials') && notMenuNeed(returnPermissionModel('materials'))) ||
                                (returnPermissionModel('projectspending') && notMenuNeed(returnPermissionModel('projectspending'))) ||
                                (returnPermissionModel('clientaccount') && notMenuNeed(returnPermissionModel('clientaccount'))) ||
                                (returnPermissionModel('quotation')) ||
                                (returnPermissionModel('finishingschedule') && notMenuNeed(returnPermissionModel('finishingschedule')))
                            ) && (
                                    <hr className='border-secondary side_bar_divider' />
                                )}

                            {/* <li className="side_nav_item">
                                <Link
                                    to={'my-subscription'}
                                    onClick={navLinkClick}
                                    className={`side_nav_link p-ripple ${isMySubscriptionActive ? 'active' : ''}`}>
                                    <i className="ri-calendar-schedule-line"></i>
                                    <span className='side_bar_label'>My subscriptions</span>
                                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                </Link>
                            </li> */}

                            <li className="side_nav_item">
                                <Link
                                    to={'app-faq'}
                                    onClick={navLinkClick}
                                    className={`side_nav_link p-ripple ${isFaqActive ? 'active' : ''}`}>
                                    <i className="ri-questionnaire-line"></i>
                                    <span className='side_bar_label'>Faq</span>
                                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                </Link>
                            </li>

                            <li className="side_nav_item">
                                <Link
                                    to={'app-contact-us'}
                                    onClick={navLinkClick}
                                    className={`side_nav_link p-ripple ${isContactUsActive ? 'active' : ''}`}>
                                    <i className="ri-message-3-line"></i>
                                    <span className='side_bar_label'>Contact Us</span>
                                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                </Link>
                            </li>
                        </ul>
                    )}
                </div>

                <div className="design_rights">
                    <p>Powered by&nbsp;</p>
                    <img src="/assets/images/traqdo_logo.svg" draggable={false} alt="Traqdo" />
                </div>
            </aside>

            <InfoModal
                show={showInfoModal}
                onClose={handleCloseInfoModal}
                title="Stay Tuned!"
                info="This feature is currently under development on the web and will be available soon. In the meantime, you can use this feature on our mobile app."
                showAppLink={true}
            />
        </React.Fragment>
    );
};

export default Sidebar;
